define([
  'jquery',
  'underscore',
  'marionette',
  'behaviors/form_errors_behavior',
  'backbone.syphon',
], function ($, _, Marionette, FormErrorsBehavior) {
  return Marionette.View.extend({
    el: '#content_layout',

    behaviors: {
      formErrors: {
        behaviorClass: FormErrorsBehavior,
      },
    },

    ui: {
      /* Pagination */
      tableBody: '#powerball_tbody',
      pageButtonWrapper: '.page-button-wrapper',
      pageButton: '.page-button',
      prevButton: '.prev-button',
      nextButton: '.next-button',

      /* Toast */
      toast: '#toast_success',
      toastText: '#toast_text_success',
      toastMessage: '#toast-message',

      tryGameButton: '.ticket-button'
    },

    events: {
      'click @ui.pageButton': function (e) {
        this.handlePageButton(e);
      },
      'click @ui.prevButton': function () {
        this.handlePrevButton();
      },
      'click @ui.nextButton': function () {
        this.handleNextButton();
      }
    },

    initialize: function () {
      this.bindUIElements();
      this.load();
    },

    handlePageButton: function (e) {
      const page = $(e.target).data('page');

      this.loadPage(page);
    },

    handlePrevButton: function () {
      const currentPage = $('.page-button.select').data('page');

      this.loadPage(currentPage - 1);
    },

    handleNextButton: function () {
      const currentPage = $('.page-button.select').data('page');

      this.loadPage(currentPage + 1);
    },

    loadPage: function (page = 1, limit = 10) {
      const that = this;

      $.ajax({
        url: `/rest_promotion/powerball_apply_tickets_data`,
        method: "GET",
        data: {
          'page': page,
          'limit': limit,
        },
        success: function (data) {
          const { currentPage, totalPages } = data.meta;

          const html = data.data.map((history, index) => `
            <tr>
              <td>
                <div>${(currentPage - 1) * 10 + index + 1}</div>
              </td>
              <td>
                <div class="ball-wrapper">
                  <div class="ball">${history.ball1}</div>
                  <div class="ball">${history.ball2}</div>
                  <div class="ball">${history.ball3}</div>
                  <div class="ball">${history.ball4}</div>
                  <div class="ball">${history.ball5}</div>
                  <div class="ball bonus">${history.powerball}</div>
                </div>
              </td>
              <td>
                <div>${history.type === 'auto' ? window.translation_auto_select : window.translation_manual_select}</div>
              </td>
              <td>
                <div>${history.resultDate}</div>
              </td>
            </tr>
          `)

          that.ui.tableBody.empty();
          that.ui.tableBody.html(html);

          that.ui.prevButton.show();
          that.ui.nextButton.show();

          if (currentPage === 1) that.ui.prevButton.hide();
          if (currentPage === totalPages) that.ui.nextButton.hide();

          const startPage = Math.floor((currentPage - 1) / 5) * 5 + 1;
          const endPage = Math.min((Math.floor((currentPage - 1) / 5) + 1) * 5, totalPages);

          that.ui.pageButtonWrapper.empty();

          for (let i = startPage; i <= endPage; i++) {
            const button = document.createElement('button');

            button.classList.add('page-button');
            button.setAttribute('data-page', i);
            button.innerHTML = i;
            button.addEventListener('click', this.handlePageButton);

            $(that.ui.pageButtonWrapper).append(button);
          }

          $('.page-button').removeClass('select');
          $('.page-button').each(function () {
            if ($(this).data('page') === currentPage) {
              $(this).addClass('select');
            }
          });
        },
        error: function (xhr, textStatus, errorThrown) {
          alert(xhr.responseJSON.message);
        },
      });
    },

    load: function () {
      /* Variable */
      let target = { phaze: 0 };
      let gameCount = undefined;
      let gameType = undefined;
      let currentGame = undefined;
      let balls = Array.from({ length: 6 }, () => ({ white: new Set(), power: 0 }));

      const init = () => {
        observer.phaze = 1;
        gameCount = undefined;
        gameType = undefined;
        currentGame = undefined;
        balls = Array.from({ length: 6 }, () => ({ white: new Set(), power: 0 }));
      }

      /* Constant */
      const AUTOMATIC = Symbol('automatic');
      const MANUAL = Symbol('manual');

      /* Utility */
      const fillRandom = (ball) => {
        while (ball.white.size < 5) {
          const randomNumber = Math.floor(Math.random() * 69) + 1;

          if (ball.white.has(randomNumber)) continue;
          ball.white.add(randomNumber);
        }

        if (!ball.power) ball.power = Math.floor(Math.random() * 26) + 1;
      };

      /* Modal */
      const modal = document.querySelector('.dialog.powerball');
      const pickButtons = document.querySelectorAll('.ticket-button');
      const closeButton = document.querySelector('.close-button');

      pickButtons.forEach((pickButton) =>
        pickButton.addEventListener('click', () => {
          init();
          modal.showModal();
        })
      );

      closeButton.addEventListener('click', () => {
        modal.close();
      });

      /* Phaze */
      const phazes = modal.querySelectorAll('.phaze');

      const changePhaze = (nextPhaze) => {
        phazes.forEach((phaze) => phaze.classList.remove('current'));
        document.querySelector(`.phaze-${nextPhaze}`).classList.add('current');
      };

      const setupPhaze = (phaze) => {
        const wrapper = modal.querySelector(`.phaze-${phaze} .wrapper`);
        const modalHead = modal.querySelector(`.phaze-${phaze} .modal-head`);
        const modalButton = modal.querySelector(`.phaze-${phaze} .modal-button`);

        if (phaze === 3) {
          wrapper.innerHTML = '';

          Array.from({ length: gameCount }, (_, i) => {
            if (gameType === AUTOMATIC) fillRandom(balls[i]);

            const item = document.createElement('div');
            item.classList.add('item');

            const col1 = document.createElement('div');
            col1.classList.add('col');
            col1.innerHTML = window[`translation_game${i + 1}`];

            const col2 = document.createElement('div');
            col2.classList.add('col');

            const ballArray = Array.from(balls[i].white).sort((a, b) => a - b).concat(balls[i].power);

            Array.from({ length: 6 }, (_, j) => {
              const ball = document.createElement('ball');
              ball.classList.add('ball');
              ball.innerHTML = ballArray[j] ? ballArray[j] : '-';

              j === 5 && ball.classList.add('bonus');

              col2.appendChild(ball);
            });

            const col3 = document.createElement('button');
            col3.classList.add('col');

            if (gameType === MANUAL) {
              if (ballArray.every((n) => n === 0)) {
                col3.innerHTML = window.translation_select;
              } else {
                col3.classList.add('edit');
                col3.innerHTML = window.translation_edit;
              }
            } else {
              col3.classList.add('edit');
              col3.innerHTML = window.translation_reselect;
            }

            col3.addEventListener('click', () => {
              if (gameType === MANUAL) {
                currentGame = i;
                observer.phaze = 4;
              } else {
                balls[i].white.clear();
                balls[i].power = 0;

                fillRandom(balls[i]);
                setupPhaze(3);
              }
            });

            item.appendChild(col1);
            item.appendChild(col2);
            item.appendChild(col3);

            wrapper.appendChild(item);
          });

          const isFinish = balls
            .slice(0, gameCount)
            .every((ball) => ball.white.size === 5 && ball.power);

          if (isFinish) modalButton3.disabled = false;
        } else if (phaze === 4) {
          const ballSet = balls[currentGame].white;

          wrapper.innerHTML = '';
          modalHead.innerHTML = `${window[`translation_game${currentGame + 1}`]} ${window.translation_select_number}`;
          ballSet.size < 5 && (modalButton.disabled = true);

          Array.from({ length: 69 }, (_, i) => {
            const element = document.createElement('button');
            element.classList.add('number');
            element.innerHTML = i + 1;

            if (ballSet.has(i + 1)) {
              element.classList.add('select');
            }

            element.addEventListener('click', () => {
              if (ballSet.has(i + 1)) {
                ballSet.delete(i + 1);
                element.classList.remove('select');
                modalButton.disabled = true;
                return;
              }

              if (ballSet.size === 5) return;

              ballSet.add(i + 1);
              element.classList.add('select');

              if (ballSet.size === 5) {
                modalButton.disabled = false;
              }
            });

            wrapper.appendChild(element);
          });
        } else if (phaze === 5) {
          wrapper.innerHTML = '';
          !balls[currentGame].power && (modalButton.disabled = true);

          Array.from({ length: 26 }, (_, i) => {
            const element = document.createElement('button');
            element.classList.add('number');
            element.innerHTML = i + 1;

            if (balls[currentGame].power === i + 1) {
              element.classList.add('select');
            }

            element.addEventListener('click', () => {
              if (balls[currentGame].power === i + 1) {
                balls[currentGame].power = 0;
                element.classList.remove('select');
                modalButton.disabled = true;
                return;
              }

              if (balls[currentGame].power) return;

              balls[currentGame].power = i + 1;
              element.classList.add('select');
              modalButton.disabled = false;
            });

            wrapper.appendChild(element);
          });
        }
      };

      const observer = new Proxy(target, {
        set(object, property, value) {
          if (property === 'phaze' && object[property] !== value) {
            changePhaze(value);
            setupPhaze(value);
            object[property] = value;
            return true;
          }
        },
      });

      /* Phaze1 */
      const phaze1 = phazes[0];
      const buttons1 = phaze1.querySelectorAll('.col');
      const modalButton1 = phaze1.querySelector('.modal-button');

      buttons1.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          gameCount = index + 1;

          buttons1.forEach((element) => element.classList.remove('select'));
          event.target.classList.add('select');

          modalButton1.disabled = false;
        });
      });

      modalButton1.addEventListener('click', () => {
        // Check playable

        buttons1.forEach((element) => element.classList.remove('select'));
        modalButton1.disabled = true;

        observer.phaze = 2;
      });

      /* Phaze2 */
      const phaze2 = phazes[1];
      const buttons2 = phaze2.querySelectorAll('.col');
      const modalButton2 = phaze2.querySelector('.modal-button');

      buttons2.forEach((button, index) => {
        button.addEventListener('click', (event) => {
          gameType = index === 0 ? AUTOMATIC : MANUAL;

          buttons2.forEach((element) => element.classList.remove('select'));
          event.target.classList.add('select');

          modalButton2.disabled = false;
        });
      });

      modalButton2.addEventListener('click', () => {
        buttons2.forEach((element) => element.classList.remove('select'));
        modalButton2.disabled = true;

        observer.phaze = 3;
      });

      /* Phaze3 */
      const phaze3 = phazes[2];
      const buttons3 = phaze3.querySelectorAll('.col');
      const modalButton3 = phaze3.querySelector('.modal-button');

      buttons3.forEach((button) => {
        button.addEventListener('click', (event) => {
          buttons3.forEach((element) => element.classList.remove('select'));
          event.target.classList.add('select');

          modalButton3.disabled = false;
        });
      });

      const that = this

      modalButton3.addEventListener('click', () => {
        const type = gameType === AUTOMATIC ? 'auto' : 'manual';
        const array = balls.slice(0, gameCount).map(({ white, power }) => Array.from(white).concat(power));

        $.ajax("/rest_promotion/powerball_apply_tickets", {
          method: "POST",
          data: {
            'type': type,
            'powerballNumbers': array,
          },
          beforeSend: function () {
            that.ui.tryGameButton.prop('disabled', true)
            modal.close();
          },
          success: function (data) {
            that.toast(window.translation_application_complete, () => window.location.reload());
          },
          error: function (xhr, textStatus, errorThrown) {
            alert(xhr.responseJSON.message);
            that.ui.tryGameButton.prop('disabled', false)
          },
        });
      });

      /* Phaze4 */
      const phaze4 = phazes[3];
      const modalButton4 = phaze4.querySelector('.modal-button');

      modalButton4.addEventListener('click', () => {
        observer.phaze = 5;
      });

      /* Phaze5 */
      const phaze5 = phazes[4];
      const modalButton5 = phaze5.querySelector('.modal-button');

      modalButton5.addEventListener('click', () => {
        observer.phaze = 3;
      });
    },

    toast: function (msg = '', callback = () => {}) {
      this.ui.toastText.html(msg);
      this.ui.toast.addClass('show');

      setTimeout(() => {
        this.ui.toast.removeClass('show');
        callback();
      }, 3000);
    },
  });
});
